import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://tradnlyswnqoelcavjdd.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRyYWRubHlzd25xb2VsY2F2amRkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTg0Nzk0ODYsImV4cCI6MjA3NDA1NTQ4Nn0.SKVvOs2PSF0haJYClx28uWuEO9Avo63FhCROCUqTNoo'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Type definitions for the whitelist table
export interface WhitelistEntry {
  id?: number
  username: string
  discord?: string | null
  x?: string | null
  status: 'pending' | 'approved' | 'denied'
  created_at?: string
  updated_at?: string
  notes?: string
}

// Whitelist operations
export const whitelistService = {
  // Submit a new whitelist request
  async submitRequest(
    username: string, 
    contactMethod: 'discord' | 'x', 
    contactUsername: string
  ): Promise<WhitelistEntry> {
    const trimmedUsername = username.toLowerCase().trim();
    
    // First check if username already exists
    const existingEntry = await this.getStatus(trimmedUsername);
    if (existingEntry) {
      switch (existingEntry.status) {
        case 'pending':
          throw new Error('ur already on the waitlist. chill out and wait for a response.');
        case 'approved':
          throw new Error('ur already approved. why are u here again?');
        case 'denied':
          throw new Error('ur request was denied. cope and seethe.');
        default:
          throw new Error('username already submitted. nice try though.');
      }
    }

    // If no existing entry, proceed with insertion
    const insertData: any = {
      username: trimmedUsername,
      status: 'pending'
    };

    // Set the appropriate contact column based on method
    if (contactMethod === 'discord') {
      insertData.discord = contactUsername.trim();
      insertData.x = null;
    } else {
      insertData.x = contactUsername.trim();
      insertData.discord = null;
    }

    const { data, error } = await supabase
      .from('dork_whitelist')
      .insert([insertData])
      .select()
      .single()

    if (error) {
      // Handle database errors
      if (error.code === '23505') { // Unique constraint violation (fallback)
        throw new Error('username already submitted. nice try though.')
      }
      throw new Error(error.message || 'failed to submit request. try again later.')
    }

    return data
  },

  // Check if username already exists
  async checkUsername(username: string): Promise<boolean> {
    const { data, error } = await supabase
      .from('dork_whitelist')
      .select('username')
      .eq('username', username.toLowerCase().trim())
      .single()

    if (error && error.code !== 'PGRST116') { // PGRST116 = no rows returned
      throw new Error('failed to check username. try again.')
    }

    return !!data
  },

  // Get whitelist status for a username
  async getStatus(username: string): Promise<WhitelistEntry | null> {
    const { data, error } = await supabase
      .from('dork_whitelist')
      .select('*')
      .eq('username', username.toLowerCase().trim())
      .single()

    if (error && error.code !== 'PGRST116') {
      throw new Error('failed to get status. try again.')
    }

    return data
  }
}